export enum MarginSettingOperator {
  Plus = 'plus',
  Minus = 'minus',
}
